<template>
  <card class="wrapper">
    <AdminTitle title="账单明细" size="15px" bottom="5px"/>

    <div class="wrapper-period special-card">
      <div class="item" v-for="(item, i) in list" :key="i">
        <div class="col2">
          <el-checkbox
              v-model="bill.isPrepay"
              v-for="(bill, index) in item.billList"
              :key="index"
              disabled
          >
            第{{ bill.billNum }}期：￥{{ bill.billPrice }}
            <span v-if="bill.depositPrice > 0" class="bill-deposit">(押金抵扣￥{{ bill.depositPrice }})</span>
          </el-checkbox>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    list() {
      return this.detailInfo.storeBillOptionList || [];
    },

    billPeriodNum() {
      return this.detailInfo.billPeriodNum;
    },

    eachRentPrice() {
      return this.detailInfo.eachRentPrice;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  width: 100%;
  border-color: transparent;
  margin-top: 5px;
  border-radius: 16px;
  color: #222222;

  .wrapper-period {
    border-radius: 16px;
    padding: 15px;
  }

  .special-card {
    background: #f7f8fa;
    line-height: 35px;
    border-radius: 16px;
  }

  .bill-deposit {
    color: #ee0a24;
    font-size: 12px;
  }

  .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #222222;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    border-color: #dcdfe6;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #409eff;
  }
}
</style>
